import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

// Components
import { SortableTableDirective, SortableColumnComponent, LoaderComponent, LoaderButtonComponent } from './components';

import { ControlMessageComponent } from './components/control-message/control-message.component';

// Pipes
import {
  TruncatePipe,
  FilenamePipe,
  SafePipe,
  SafeHtmlPipe,
  GetLangPipe,
  AuthenticatedPipe,
  ApiUrlPipe,
  EmptyPipe,
} from './pipes';

// Directives
import { CommaToDotDirective } from './directives';

// Confirmation
import { ConfirmationModule } from './confirmation';

// Plugins
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';

// Modules
import { PermissionModule } from './permission';

// Extensions
import './extensions/array.extension';
import './extensions/date.extension';

@NgModule({
  declarations: [
    LoaderComponent,
    SortableColumnComponent,
    SortableTableDirective,
    TruncatePipe,
    FilenamePipe,
    SafePipe,
    SafeHtmlPipe,
    GetLangPipe,
    AuthenticatedPipe,
    ApiUrlPipe,
    EmptyPipe,
    ControlMessageComponent,
    LoaderButtonComponent,
    CommaToDotDirective,
  ],
  imports: [
    // Assets
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,

    // Plugins
    NgbModule,
    NgSelectModule,
    NgxMaskModule.forRoot(),

    // Modules
    // AuthenticationModule,
    ConfirmationModule,
    PermissionModule,
    TranslateModule,
  ],
  exports: [
    // Assets
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,

    // Features
    ConfirmationModule,
    // AuthenticationModule,
    PermissionModule,

    // Plugins
    TranslateModule,
    NgbModule,
    NgSelectModule,
    NgxMaskModule,

    // Directives
    SortableTableDirective,

    // Pipes
    FilenamePipe,
    TruncatePipe,
    SafePipe,
    SafeHtmlPipe,
    GetLangPipe,
    AuthenticatedPipe,
    ApiUrlPipe,
    EmptyPipe,

    // Components
    LoaderComponent,
    SortableColumnComponent,
    ControlMessageComponent,
    LoaderButtonComponent,

    // Directives
    CommaToDotDirective,
  ],
})
export class CoreSharedModule {}
